<template>
	<div id="header">
		<el-dialog title="修改密码" :visible.sync="dialogFormVisible">
			<el-form :model="ruleForm" :rules="pwdRules" ref="ruleForm">
				<el-form-item label="身份证" prop="idcardInput" :label-width="formLabelWidth">
					<el-input v-model="ruleForm.idcardInput" autocomplete="off" placeholder="暂无填写"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="pass" :label-width="formLabelWidth">
					<el-input v-model="ruleForm.pass" type="password" autocomplete="off" placeholder="暂无填写"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass" :label-width="formLabelWidth">
					<el-input v-model="ruleForm.checkPass" type="password" autocomplete="off" placeholder="暂无填写" @paste.native.capture.prevent="false"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
    			<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<el-row v-if="$store.state.layout == 0" class="header" type="flex" justify="center">
			<el-col :span="3" class="logo" v-if="temp.logo"><img :src="$store.state.school_logo"></el-col>
			<el-col :span="16" class="h_menu_box">
				<el-menu v-if="!$store.state.visitor && temp.menu.show" :default-active="activeIndex" class="menu" mode="horizontal" @select="handleSelect">
					<el-menu-item index="index" v-if="temp.menu.index">我的课程</el-menu-item>
					<!-- <el-menu-item v-if="hideType === 3" index="xiaozu">学习小组</el-menu-item> -->
					<el-submenu v-if="(menu_show([3,4]) && temp.menu.pIteamGroup) || select_course_mode!=0" index="3">
							<template slot="title" class="pIteam">学习任务</template>
							<!-- <el-menu-item index="kaoshi">考试安排</el-menu-item> -->
							<el-menu-item index="kebiao" v-if="menu_show([3]) && temp.menu.pIteamGroup">课程表</el-menu-item>
							<el-menu-item index="zuoye" v-if="menu_show([3]) && temp.menu.pIteamGroup">我的作业</el-menu-item>
							<el-menu-item index="paper" v-if="menu_show([3,4]) && temp.menu.pIteamGroup">论文信息</el-menu-item>
							<el-menu-item index="course_selection_center" v-if="select_course_mode!=0">选课</el-menu-item>
							<!-- <el-submenu index="2-4">
								<template slot="title">选项4</template>
								<el-menu-item index="2-4-1">选项1</el-menu-item>
								<el-menu-item index="2-4-2">选项2</el-menu-item>
								<el-menu-item index="2-4-3">选项3</el-menu-item>
							</el-submenu> -->
					</el-submenu>
					<el-menu-item v-if="temp.menu.exam_list" index="exam_list">我的考试</el-menu-item>
					<!-- <el-menu-item v-if="temp.menu.payments" index="exam_list">费用查询</el-menu-item> -->
					<el-menu-item v-if="menu_show([3]) && temp.menu.chengji" index="chengji">成绩查询</el-menu-item>
					<el-menu-item index="biji" v-if="temp.menu.biji">我的笔记</el-menu-item>
					<el-menu-item index="tongji" v-if="temp.menu.tongji">学习统计</el-menu-item>
					<!-- <el-menu-item v-if="menu_show([1,5,7,8])" index="guide">报考指南</el-menu-item> -->
					<!-- <el-menu-item index="guide">报考指南</el-menu-item>
					<el-menu-item index="problem">常见问题</el-menu-item> -->
					<el-menu-item v-if="menu_show([2,6,9,10]) && temp.menu.problem" index="problem">常见问题</el-menu-item>
					<!-- <el-menu-item v-if="true" index="material">资料汇总</el-menu-item> -->
					<el-menu-item v-if="menu_show([2,4,5,6,7,8,9,10]) && temp.menu.material" index="material">资料汇总</el-menu-item>
					<el-menu-item v-if="menu_show([4]) && temp.menu.own_examination" index="own_examination">我的自考</el-menu-item>
					<el-menu-item index="course_selection" v-if="temp.menu.course_selection">选课中心</el-menu-item>
					<el-menu-item index="certificate_download" v-if="temp.menu.certificate_download">证书下载</el-menu-item>
					<el-menu-item index="announcement_list" v-if="temp.menu.announcement_list">通知公告</el-menu-item>
					<el-menu-item index="graduate_form" v-if="temp.menu.graduate_form">毕业信息</el-menu-item>
					<el-submenu v-if="temp.menu.userIndex && $store.state.identity_list.length" index="5">
						
							<template slot="title" class="pIteam">个人信息</template>
							<el-menu-item index="userIndex">学籍信息</el-menu-item>
							<el-menu-item @click.native="remove_bind" v-if="unionid">微信绑定（{{wx_name}}）</el-menu-item>
							<el-menu-item index="name_attestation" v-if="ruleForm.is_certified==1&&temp_index.attestation">实名认证</el-menu-item>
							<el-menu-item @click.native="dialogFormVisible = true">修改密码</el-menu-item>
							<el-menu-item index="purchased" v-if="temp_index.purchased">已购课程</el-menu-item>
							<el-menu-item index="logs">操作日志</el-menu-item>

					</el-submenu>
					<!-- <el-menu-item index="userIndex" v-if="temp.menu.userIndex && $store.state.identity_list.length">个人信息</el-menu-item> -->
					<div class="show_wechatProgram" @mouseover="over_wechatProgram" @mouseleave="leave_wechatProgram" v-if="temp.wechatProgram">
						<i class="iconfont">&#xe605;</i>
						<div class="imgBox" v-show="show_program">
							<img :src="global.oss_website+'/pc/images/wechatProgram.jpg'">
						</div>
					</div>
					<div :class="'show_wechatProgram '+(new_message?'new_message':'')" @click="notifyList" v-if="temp.new_message">
						<i class="iconfont">&#xe60a;</i>
					</div>
				</el-menu>
				<ul class="exam_uinfo" v-if="temp.menu.exam_uinfo">
					<li>证件号：{{ idcard }}</li>
					<li>姓名：{{ exam_name }}</li>
				</ul>
			</el-col>
			<el-col :span="3" class="headRight">
				<div v-if="$store.state.visitor" @click="login()" class="loginOut">登录</div>
				<div v-else @click="loginOut()" class="loginOut">退出</div>
			</el-col>
		</el-row>
		<el-row v-else-if="$store.state.layout == 1" type="flex" justify="center" class="rangeHeader">
			<el-col :span="16">
				<div class="logoBox">
					<img :src="global.oss_website+'/pc/images/login/logo.jpg'" class="logo" v-if="temp.rangeHeader.logo">
					<p class="logoDesc">让线上教育更轻松</p>
				</div>
				<div class="rightItem">
					<div class="userInfo">
						<i class="iconfont">&#xe683;</i>
						{{username}}
					</div>
					<div @click="loginOut()" class="loginOut">退出</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'headView'
	,props:["muban_bol"]
	,data () {
		var validatePass = (rule, value, callback) => {
			// console.log(value);
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
			if (value === '' || value === undefined) {
				callback(new Error('请输入密码'));
			} else if (!pwdReg.test(value)) {
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			// console.log(value);
			if (value === '' || value === undefined) {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
      		temp: this.temp.head,
			temp_index: this.temp.userCenter.index,
			username:'',
			show_program:false,
			route_data:[
				// {rname}
			],
			ruleForm: {
				profile:{},
				grade:{},
				major:{},
				market:{},
				mould:{},
				school:{},
				org:{},
				uname: '',
				uphone: '',
				area: '',
				email: '',
				school: '',
				grade: '',
				cengci: '',
				zhuanye: '',
				idcard:'',
				idcardInput:'',
				pass:'',
				checkPass:'',
				certified:false, //是否已经实名认证
				is_certified:2, //是否开启实名认证
			},
			wx_name:'',
			unionid:'',
			new_message:false,

			idcard: '',
			exam_name: '',
			select_course_mode:0,
			dialogFormVisible:false,
			formLabelWidth: '120px',
			pwdRules:{
				//required：是否必填，message错误提示内容，trigger触发方式
				idcardInput: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
				],
				pass: [
					// { required: true, message: '请输入新密码', trigger: 'blur' },
					{ validator: validatePass, required: true, trigger: 'blur' },
				],
				checkPass: [
					// { required: true, message: '请再次输入密码', trigger: 'blur' },
            		{ validator: validatePass2, required: true, trigger: 'blur' },
				],
			},
		}
	}
	,mounted:function(){
		let that = this
			,serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui
        if(this.$cookies.get("token")){
			this.$selfjs.getUserCallFn(this, (res)=>{
				this.idcard = res.idcard
				this.exam_name = res.nick_name
			})
			// 获取常量
			this.$store.dispatch('get_const')
		}
		this.$selfjs.getUserCallFn(this, function(res){
			let idcard = res.idcard,
				idcardType = '身份证'
			that.ruleForm.idcard=idcard						//证件号码
			that.wx_name=res.wx_name						//微信昵称
			that.unionid=res.unionid						//微信unionid
			if(idcard.length <= 15){
				idcardType = '其他'
			}
			that.ruleForm.yidong=res.yidong || "未申请"	//异动审核状态
			that.ruleForm.certified = res.certified
			that.ruleForm.is_certified = res.school.is_certified
		})
		if(this.$store.state.visitor){
			return false
		}
		this.$store.dispatch('get_identity_list').then(res=>{
			// console.log(res);
			if (res.length>=1) {
				//获取用户数据
				this.$selfjs.getUserCallFn(this,function(res){
					that.username = res.nick_name
					that.select_course_mode = res.school.extra.study.required.select_course_mode
				})
				this.get_notify_total()
			}
		})	
	}
	,watch:{
		$route(to,form){
			if (to.name=='notify_info') {
				this.get_notify_total()
			}
			// console.log(form);
			// console.log(this.$route.path);
			// this.activeIndex = this.$route.path;
			// location.reload();
		}
	}
	,methods:{
		// 跳转到登录页
		login(){
			this.$router.push({
				path: '/web/login/',
				name: 'login',
				query: '',
				params: '',
			})
			this.$emit("swmuban", false);		//修改app.vue 的 muban_bol 值
		},
		//退出登录
		loginOut(){
			var that=this
			this.$confirm('确认退出登录？')
			.then(_ => {
				let logout_url=this.global.serverSrc + this.global.qianzui + "/login/logout"
				this.$ajax.get(logout_url)
				.then(function(res){
					let resData=res.data;
					if(resData.code==0){
						that.$selfjs.loginOutFn(that, "location")
					}else{
						this.$message.error(resData.message)
						// console.log(resData.message);
					}
				})
			})
			.catch(_ => {
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		}
		//顶部点击事件
		,handleSelect(key, keyPath) {
			// console.log(this);
			console.log(key);
			if (key=='material') {
				this.$selfjs.swhead(this,key,{mould_id:this.$store.state.mould_id});
			}else if(key=='index'){
				this.$store.dispatch('get_identity_list').then(res=>{
					// console.log(res);
					if (res.length>=1) {
						this.$selfjs.swhead(this,key);
					}
				})
			}else if(key){
				console.log(this.$store.state.activeIndex);
				this.$selfjs.swhead(this,key);
				this.$store.commit("activeIndex", key)	//初始化导航值
			}
			
		},
		// 顶部入口显示
		menu_show(arr){
			let val = false
			if(arr.indexOf(this.hideType) >= 0){
				val = true
			}
			return val
		},
		//鼠标悬停显示小程序码
		over_wechatProgram(){
			this.show_program = true
		},
		leave_wechatProgram(){
			this.show_program = false
		},
		//点击信息
		notifyList(){
			this.$selfjs.swhead(this,'notify');
			this.$store.commit("activeIndex", 'notify')	//初始化导航值
			this.$selfjs.jumpPage(this, {
				title:"消息通知",
				router:"/web/notify/",
				name: 'notify',
				query:{page:'notify'}
			})
		},
		//新通知消息条数
		get_notify_total(){
			let url = this.global.serverSrc+this.global.qianzui+'/notify/notifyTotal';
			let token=this.$cookies.get("token")
			this.$ajax.get(url)
			.then((res)=>{
				if (res.data.data!=0) {
					this.new_message = true
				}else{
					this.new_message = false
				}
				// console.log(res);
			})
		},
		//微信解绑
		remove_bind(){
			this.$confirm('此操作将解绑该微信, 是否解绑?', '提示', {
        	  	confirmButtonText: '确定',
        	  	cancelButtonText: '取消',
        	  	type: 'warning'
        	}).then(() => {
				let that = this
				const loading = this.$loading({
          			lock: true,
          			text: 'Loading',
          			spinner: 'el-icon-loading',
          			background: 'rgba(0, 0, 0, 0.7)'
        		});
				this.$ajax.post(
					this.global.serverSrc+this.global.qianzui+'/login/wechat_unbundling'
					,this.$qs.stringify({
						unionid:this.unionid
					})
				)
				.then(function (res){
					let resData=res.data;
					if(resData.code==0){
						that.$message({
							message: '微信解绑成功',
							type: 'success'
						});
						that.unionid = ''
						that.wx_name = ''
					}else{
						that.$message.error(resData.message)
					}
					loading.close();
				}).catch(function (res){
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
        	}).catch(() => {      
        	});
		},
		// 修改密码
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var token=this.$cookies.get("token")
						,that=this
					const url = this.global.serverSrc+this.global.qianzui+'/password/reset';
					// return false
					//发送修改密码请求
					this.$ajax.post(url,
						that.$qs.stringify({
							mobile:that.ruleForm.idcardInput
							,password: that.$selfjs.getAES(that.ruleForm.pass)
						})
					)
					.then(function(res){
						let resData=res.data;
						if(resData.code==0){
							//弹出即将退出登录的提示框
							that.$alert('修改密码成功，点击确定退出登录状态！！！', '信息提示', {
								confirmButtonText: '确定',
								callback: action => {
									that.$selfjs.loginOutFn(that, "location")
								}
							});
							that.$message.close();
						}else{
							that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
	},
	computed:{
		activeIndex(){
			let activeIndex = this.$store.state.activeIndex
			if(this.$selfjs.getParamString("page")){
				activeIndex = this.$selfjs.getParamString("page")
				this.$store.commit("activeIndex", this.$selfjs.getParamString("page") )
			}
			return activeIndex
		},
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
		headerMode(){
			console.log(this.$store.state.layout ? this.$store.state.layout : 0)
			return this.$store.state.layout ? this.$store.state.layout : 0
		},
	},
	// watch:{
	// 	school_logo:{
	// 		handler (newValue, oldValue) {
	// 			console.log(newValue)
	// 			console.log('obj changed')
	// 		},
	// 		deep: true
	// 	}
	// }
}
</script>

<!-- scoped单页面有效属性 -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/head.vue